import { render } from "./UserUpdateProfilePicture.vue?vue&type=template&id=684fcdca&scoped=true"
import script from "./UserUpdateProfilePicture.vue?vue&type=script&lang=js"
export * from "./UserUpdateProfilePicture.vue?vue&type=script&lang=js"

import "./UserUpdateProfilePicture.vue?vue&type=style&index=0&id=684fcdca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684fcdca"]])

export default __exports__